export default __webpack_public_path__ + "static/messi-6b4fc5f06f7cf41ee12ad603a396e77e.jpeg";